import { render, staticRenderFns } from "./CVRequest.vue?vue&type=template&id=40c54f74"
import script from "./CVRequest.vue?vue&type=script&lang=js"
export * from "./CVRequest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports